import PlusIcon from "@rsuite/icons/Plus";
import { useContext, useEffect, useState, type FC } from "react";
import { BsTrash3 } from "react-icons/bs";
import { Checkbox, IconButton, Table } from "rsuite";
import TopBrandForm from "../components/features/inventory/TopBrandForm";
import MainLayout from "../components/MainLayout";
import { LoadingContext } from "../contexts/LoadingContext";
import { TopBrand } from "../models/inventory/brand";
import {
  addTopBrand,
  deleteTopBrand,
  getTopBrands,
  updateTopBrand,
} from "../services/inventory/BrandApi";
import { errorToast } from "../utils/helper-ui";
import { money } from "../utils/helper";
import moment from "moment";
const { Column, HeaderCell, Cell } = Table;
interface TopBrandPageProps {}

const TopBrandPage: FC<TopBrandPageProps> = ({}) => {
  const [mounted, setMounted] = useState(false);
  const [topBrands, setTopBrands] = useState<TopBrand[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [selected, setSelected] = useState<TopBrand>();
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === topBrands.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < topBrands.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? topBrands.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  const removeTopBrand = async (topBrandId: string) => {
    const confirmRemove = window.confirm(
      `Are you sure to remove top brand ${topBrandId}?`
    );
    if (!confirmRemove) return;
    setIsLoading(true);
    try {
      await deleteTopBrand(topBrandId);
      getTopBrands()
        .then((v) => v.json())
        .then((v) => setTopBrands(v.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    getTopBrands()
      .then((v) => v.json())
      .then((v) => setTopBrands(v.data));
  }, [mounted]);

  const addNewTopBrand = async (data: TopBrand) => {
    try {
      setIsLoading(true);
      if (selected) {
        await updateTopBrand(selected.brand!.id!, data);
      } else {
        await addTopBrand(data);
      }
      getTopBrands()
        .then((v) => v.json())
        .then((response) => {
          setTopBrands(response.data);
          setModalFormOpen(false);
        });
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Top Brand</h1>
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Add Top Brand
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
      <div className="w-full overflow-y-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50 w-32">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Logo</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Value</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {topBrands.map((item, i) => (
              <tr key={item.id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={item.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((e) => e === item.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold"
                    onClick={() => {
                      setSelected(item);
                      setModalFormOpen(true);
                    }}
                  >
                    {item?.brand?.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  {item.brand?.logo && (
                    <img
                      src={item.brand?.logo}
                      style={{ height: 50 }}
                      alt="logo"
                    />
                  )}
                </td>
                <td className="px-4 py-2 border">{money(item.value)}</td>
                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800"
                    size={16}
                    onClick={() => removeTopBrand(item.brand_id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )} */}
      {/* <Table minHeight={700} data={topBrands} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>{topBrands.indexOf(rowData as TopBrand) + 1}</div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelected(rowData as TopBrand);
                  setModalFormOpen(true);
                }}
              >
                {rowData.brand?.name}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={100} resizable>
          <HeaderCell>Logo</HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) =>
              rowData.brand?.logo && (
                <img
                  src={rowData.brand?.logo}
                  style={{ height: 50 }}
                  alt="logo"
                />
              )
            }
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Value</HeaderCell>
          <Cell>{(rowData) => <div>{money(rowData.value)}</div>}</Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removeTopBrand(rowData.brand_id)}
              />
            )}
          </Cell>
        </Column>
      </Table> */}
      <TopBrandForm
        open={modalFormOpen}
        onClose={() => setModalFormOpen(false)}
        onSubmit={(val) => {
          addNewTopBrand(val);
        }}
        topBrand={selected}
      />
    </MainLayout>
  );
};
export default TopBrandPage;
